import { HTMLInputTypeAttribute } from "react";

interface Props {
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: HTMLInputTypeAttribute | undefined;
  inputClassName?: string;
  labelClassName?: string;
  containerClassname?: string;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  /** Forwarded to the native input. For type="date" this greys the
   *  out-of-range days out in the picker, instead of letting one be chosen
   *  and only rejecting it on save. */
  min?: string | number;
  max?: string | number;
}

export const FormInput = ({
  label,
  value,
  onChange,
  type,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  disabled,
  containerClassname,
  ...rest
}: Props) => {
  return (
    <div className={`mb-4 ${containerClassname}`}>
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <input
        {...rest}
        disabled={disabled}
        value={value}
        onChange={onChange}
        type={type}
        className={`w-full h-[46px] px-4 bg-sky-lighter border ${
          error ? "border-red-base" : "border-gray-border"
        } ${
          error ? "focus:border-red-base" : "focus:border-focused-border"
        } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
        placeholder={placeholder}
      />
    </div>
  );
};
